
import { store } from '../store'
//Administrator
import Login from '../views/login.vue'
import Dashboard from '../views/dashboard.vue'
import User from '../views/user/index.vue'
import Party from '../views/party/index.vue'
import Product from '../views/product/index.vue'
import History from '../views/history/index.vue'
import Order from '../views/order/index.vue'
import Location  from '../views/location.vue'
import Allbid from '../views/all.vue'
import Report from '../views/export.vue'

// Custmor
import custmorDashboard from '../views/customer/dashboard.vue'
import CustomerOrder from '../views/customer/orders.vue'
import CustomerParty from '../views/customer/party.vue'
import CustomerSetting from '../views/customer/setting.vue'

//Logout
import Logout from '../views/logout.vue'
import Forgot from '../views/user/forgot.vue'
import Change from '../views/user/change.vue'



// Customer


export default[
    // Login
    {path: '/login', name: 'login', component: Login, meta: { requiresVisitor: true }},
    {path: '/forgot/password', name: 'forgot', component: Forgot, meta: { requiresVisitor: true }},
    {path: '/update/password', name: 'updatepassword', component: Change, meta: { requiresVisitor: true }},

    // Backend
    {path: '/all', name: 'allbid', component: Allbid, 
    redirect: store.state.role == 'broker' || store.state.role == 'custmor' ? { name: 'customerdashboard' } : '', 
    meta: { requiresAuth: true} },
    {path: '/reports', name: 'report', component: Report, 
    redirect: store.state.role == 'broker' || store.state.role == 'custmor' ? { name: 'customerdashboard' } : '', 
    meta: { requiresAuth: true} },
    {path: '/', name: 'dashboard', component: Dashboard, 
    redirect: store.state.role == 'broker' || store.state.role == 'custmor' ? { name: 'customerdashboard' } : '', 
    meta: { requiresAuth: true} },
    {path: '/user', name: 'user', component: User, 
    redirect: store.state.role == 'broker' || store.state.role == 'customer' ? { name: 'customersetting' } : '', meta: { requiresAuth: true}},
    {path: '/party', name: 'party', component: Party, 
    redirect: store.state.role == 'broker' || store.state.role == 'customer' ? { name: 'customerparty' } : '', meta: { requiresAuth: true} },
    {path: '/product', name: 'product', component: Product, 
    redirect: store.state.role == 'broker' || store.state.role == 'customer' ? { name: 'customerdashboard' } : '',  meta: { requiresAuth: true} },
    {path: '/updates/history', name: 'history', component: History, meta: { requiresAuth: true} },
    {path: '/orders/:product', name: 'order', component: Order,
    redirect: store.state.role == 'broker' || store.state.role == 'customer' ? { name: 'customerdashboard' } : '', meta: { requiresAuth: true} },
    {path: '/location', name: 'location', component: Location, meta: { requiresAuth: true} },
    
    
    //Custmor
    {path: '/customer', name: 'customerdashboard', component: custmorDashboard,
    redirect: store.state.role == 'admin' || store.state.role == 'editor' || store.state.role == 'analyser' ? { name: 'dashboard' } : '',
    meta: { requiresAuth: true} },
    {path: '/customer/orders/:product', name: 'customerorder', component: CustomerOrder,
    redirect: store.state.role == 'admin' || store.state.role == 'editor' || store.state.role == 'analyser' ? { name: 'dashboard' } : '',
    meta: { requiresAuth: true} },
    {path: '/customer/party', name: 'customerparty', component: CustomerParty, 
    redirect: store.state.role == 'admin' || store.state.role == 'editor' || store.state.role == 'analyser' ? { name: 'customerdashboard' } : '',
    meta: { requiresAuth: true} },
    //{path: '/custmor/pendingorder', name: 'custmordashboard', component: custmorPendingOrder, meta: { requiresAuth: true} },
    //{path: '/custmor/finalorder', name: 'custmordashboard', component: custmorFinalOrder, meta: { requiresAuth: true} },
    {path: '/setting', name: 'customersetting', component: CustomerSetting,
    redirect: store.state.role == 'admin' ? { name: 'user' } : '',
    meta: { requiresAuth: true} },

    //Logout
    {path: '/logout', name: 'logout', component: Logout, meta: { requiresAuth: true} },
]